import { createAsyncThunk } from '@reduxjs/toolkit';
import { graphqlRequest, hasGraphQLNetworkError } from '~/adapters/graphqlRequest';
import { GetLifecycleSurveyTypesDocument, GetLifecycleSurveyTypesQueryResult } from '~/gql/graphql';

const getLifecycleSurveyTypes = createAsyncThunk(
  'lifecycleSurveyTypes/getLifecycleSurveyTypes',
  async (_, { rejectWithValue }) => {
    const res = await graphqlRequest<GetLifecycleSurveyTypesQueryResult>(GetLifecycleSurveyTypesDocument);

    if (hasGraphQLNetworkError(res)) return rejectWithValue(res.error);

    return res.data?.getLifecycleSurveyTypes;
  },
);

export const lifecycleSurveyTypesActions = {
  getLifecycleSurveyTypes,
};
